import { render, staticRenderFns } from "./gb-whatsapp-not-opening.vue?vue&type=template&id=4e71e934&scoped=true"
import script from "./gb-whatsapp-not-opening.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-not-opening.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-not-opening.vue?vue&type=style&index=0&id=4e71e934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e71e934",
  null
  
)

export default component.exports